
import {
  Box,
  Grid,
  Typography,
  Stack,
  Button,
  Divider,
  CardContent,
  Card,
  Tabs,
  Tab,
  Pagination,
  PaginationItem,
  Skeleton,
  TextField,
  InputAdornment,
  Paper,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import { useNavigate } from "react-router-dom";
// import Header from "../../auth/Header";
import Headernew from "../../auth/headernew";
import OceshaLogo from "../../../assets/ocesha_images/ocesha_logo.png";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SearchIcon from "@mui/icons-material/Search";
import MuiChip from "@mui/material/Chip";
import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";

// ── Light theme tokens matching MyDashboard & CreatorDirectory ──
const interFont = "'Inter', sans-serif";
const cardBg = "#161b22";
const cardBorder = "#21262d";
const primary = "#3b82f6";
const primaryLight = "#60a5fa";

const filters = [
  "All",
  "Business",
  "Fitness",
  "Marketing",
  "Podcasting",
  "Personal Growth",
];

export default function CoursesDirectory() {
  const navigate = useNavigate();
  const supportUserid = process.env.REACT_APP_SUPPORT_USER_ID || "";
  const loggedIn = localStorage.getItem("logged_in");

  const [active, setActive] = useState("All");
  const [courses, setCourses] = useState<any>();
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loadingcourses, setLoadingCourses] = useState<boolean>();
  const [searchText, setSearchText] = useState("");
  const location = useLocation();

  
  const partnerName = location.pathname.split("/").filter(Boolean).pop();
  //const partnerName = location.pathname.endsWith("/GBA") ? "GBA" : "";

  const limit = 12;
  const user_email = localStorage.getItem("user_email") || "";
  const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";

  // ── ALL LOGIC UNTOUCHED ──
  const renderStars = (rating: number) => {
    const safeRating = Math.round(rating || 0);
    return Array.from({ length: 5 }, (_, index) => (
      <StarIcon
        key={index}
        sx={{
          fontSize: 14,
          color: index < safeRating ? "#facc15" : "#374151",
        }}
      />
    ));
  };

  const shouldSendPartner =
    partnerName /* === "GBA" */ ||
    localStorage.getItem("partner_name") /* === "GPA" */;

  const apiPartnerName = shouldSendPartner ? "GPA" : "";

  const getCourseDirectorieslisting = async (
    currentPage = page,
    search = searchText
  ) => {
    setLoadingCourses(true);
    try {
      const res = await axios.get(
        `${apiUrl}/api/prompts/courses/all`, {
        params: {
          search,
          page: currentPage,
          limit,
          ...((partnerName /* === "GBA" */ || localStorage.getItem('partner_name') /* === 'GPA' */) && { partner_name: (partnerName || localStorage.getItem('partner_name'))/* "GPA" */ }),
        }
      },/* ?search=${search}&page=${currentPage}&limit=${limit} *//* ...(partnerName === "GPA" && { partner_name: "GPA" }) */
      );
      setCourses(res?.data?.courses);
      setTotalPages(res?.data?.pagination?.total_pages);
    } catch (error: any) {
      console.log("Error fetching courses directories=>", error);
      toast.error(error);
    } finally {
      setLoadingCourses(false);
    }
  };

  useEffect(() => {
    getCourseDirectorieslisting(page);
  }, [page]);

  return (
    <>
      <Headernew />

      <Box
        className="overlay-container"
        sx={{ px: { xs: 2, md: 6 }, minHeight: "100vh" }}
      >
        <Box
          sx={{
            minHeight: "100vh",
            color: "#e5e7eb",
            pt: 4,
            pb: 6,
            maxWidth: 1100,
            mx: "auto",
          }}
        >

          <Button
            startIcon={<NavigateBeforeIcon />}
            onClick={() => navigate(-1)}
            sx={{
              fontFamily: interFont,
              fontWeight: 500,
              fontSize: 13,
              textTransform: "none",
              color: "#9ca3af",
              mb: 2,
              px: 0,
              minWidth: "auto",
              "&:hover": { color: primaryLight, background: "transparent" },
            }}
          >
            Back
          </Button>

          {/* Page title — matches MyDashboard style */}
          <Typography
            fontFamily={interFont}
            fontSize={22}
            fontWeight={600}
            letterSpacing="-0.02em"
            color={primaryLight}
          >
            Courses Directory
          </Typography>
          <Typography
            fontFamily={interFont}
            fontSize={13}
            color="#9ca3af"
            mb={3}
          >
            Explore courses from expert creators
          </Typography>

          {/* Search + Filters */}
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "stretch", md: "center" }}
            mb={4}
            spacing={3}
          >
            {/* Search */}
            <Box>
              <Typography
                fontFamily={interFont}
                fontSize={13}
                mb={0.5}
                color="#9ca3af"
                fontWeight={500}
              >
                Search
              </Typography>
              <TextField
                placeholder="Search by name"
                size="small"
                sx={{
                  width: 280,
                  background: "#161b22",
                  borderRadius: "8px",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    "& fieldset": { borderColor: cardBorder },
                    "&:hover fieldset": { borderColor: primaryLight },
                    "&.Mui-focused fieldset": { borderColor: primary },
                  },
                  "& input": {
                    color: "#e5e7eb",
                    fontFamily: interFont,
                    fontSize: 13,
                    "&::placeholder": { color: "#6b7280", opacity: 1 },
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon sx={{ color: "#6b7280", fontSize: 18 }} />
                    </InputAdornment>
                  ),
                }}
                value={searchText}
                onChange={(e) => {
                  const value = e.target.value;
                  setSearchText(value);
                  getCourseDirectorieslisting(1, value);
                }}
              />
            </Box>

            {/* Filters */}
            <Box>
              <Typography
                fontFamily={interFont}
                fontSize={13}
                mb={0.5}
                color="#9ca3af"
                fontWeight={500}
              >
                Filters
              </Typography>
              <Box
                sx={{
                  background: "#21262d",
                  borderRadius: "8px",
                  p: "4px",
                  display: "block",
                  maxWidth: "100%",
                }}
              >
                <Tabs
                  value={filters.indexOf(active)}
                  onChange={(_: any, newValue: any) => {
                    const value = filters[newValue];
                    setActive(value);
                    if (value === "All") {
                      setSearchText("");
                      getCourseDirectorieslisting(1, "");
                    } else {
                      setSearchText(value);
                      getCourseDirectorieslisting(1, value);
                    }
                  }}
                  TabIndicatorProps={{ style: { display: "none" } }}
                  variant="scrollable"
                  scrollButtons={false}
                  sx={{
                    minHeight: "unset",
                    maxWidth: "100%",
                    "& .MuiTabs-scroller": { overflowX: "auto" },
                    "& .MuiTabs-flexContainer": {
                      gap: "4px",
                      flexWrap: "nowrap",
                    },
                  }}
                >
                  {filters.map((f) => (
                    <Tab
                      key={f}
                      label={f}
                      disableRipple
                      sx={{
                        minHeight: "unset",
                        textTransform: "none",
                        fontFamily: interFont,
                        fontSize: 13,
                        color: "#9ca3af",
                        borderRadius: "6px",
                        px: 1.5,
                        py: 0.5,
                        "&.Mui-selected": {
                          background: "#161b22",
                          border: "1px solid #30363d",
                          color: "#e5e7eb",
                          fontWeight: 600,
                        },
                      }}
                    />
                  ))}
                </Tabs>
              </Box>
            </Box>
          </Stack>

          {/* Cards Grid */}
          <Grid container spacing={2.5}>
            {loadingcourses ? (
              Array.from(new Array(6)).map((_, i) => (
                <Grid item xs={12} sm={6} md={4} key={i}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: cardBg,
                      border: `1px solid ${cardBorder}`,
                      borderRadius: "12px",
                      overflow: "hidden",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box sx={{ p: "12px 12px 0 12px" }}>
                      <Skeleton
                        variant="rounded"
                        width="100%"
                        sx={{
                          borderRadius: "10px",
                          aspectRatio: "312 / 200",
                          height: "auto",
                        }}
                      />
                    </Box>
                    <CardContent
                      sx={{
                        p: "12px 14px 14px",
                        display: "flex",
                        flexDirection: "column",
                        gap: 0.8,
                      }}
                    >
                      <Skeleton width="75%" height={22} />
                      <Skeleton width="40%" height={16} />
                      <Skeleton width="100%" height={16} />
                      <Stack direction="row" spacing={1} mt={0.3}>
                        <Skeleton variant="rounded" width={100} height={22} sx={{ borderRadius: "6px" }} />
                        <Skeleton variant="rounded" width={85} height={22} sx={{ borderRadius: "6px" }} />
                      </Stack>
                      <Skeleton width={80} height={20} />
                      <Skeleton variant="rounded" width="100%" height={36} sx={{ borderRadius: "8px", mt: 0.5 }} />
                    </CardContent>
                  </Paper>
                </Grid>
              ))
            ) : courses && courses.length > 0 ? (
              courses.map((course: any) => (
                <Grid item xs={12} sm={6} md={4} key={course._id}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: cardBg,
                      border: `1px solid ${cardBorder}`,
                      borderRadius: "12px",
                      overflow: "hidden",
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      transition: "box-shadow 0.2s ease, border-color 0.2s ease",
                      "&:hover": {
                        boxShadow: "0 4px 20px rgba(59,130,246,0.15)",
                        borderColor: "#3b82f6",
                      },
                    }}
                  >
                    {/* Course Image */}
                    <Box sx={{ p: "12px 12px 0 12px", flexShrink: 0 }}>
                      <Box
                        sx={{
                          position: "relative",
                          width: "100%",
                          aspectRatio: "312 / 200",
                          borderRadius: "10px",
                          overflow: "hidden",
                          background: "#0d1117",
                        }}
                      >
                        <Box
                          component="img"
                          src={
                            course.image_path_small ||
                            "https://images.unsplash.com/photo-1521737604893-d14cc237f11d"
                          }
                          alt={course.title}
                          sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block",
                          }}
                        />
                        {/* BESTSELLER badge — updated to match light theme */}
                        {/* <MuiChip
                          label="BESTSELLER"
                          size="small"
                          sx={{
                            position: "absolute",
                            top: 10,
                            left: 10,
                            fontSize: "10px",
                            height: 20,
                            borderRadius: "6px",
                            backgroundColor: "rgba(59,130,246,0.85)",
                            color: "#fff",
                            fontWeight: 700,
                            fontFamily: interFont,
                            letterSpacing: "0.04em",
                            backdropFilter: "blur(4px)",
                          }}
                        /> */}
                      </Box>
                    </Box>

                    {/* Card Content */}
                    <CardContent
                      sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        gap: 0.6,
                        p: "12px 16px 16px !important",
                      }}
                    >
                      {/* Title */}
                      <Typography
                        fontFamily={interFont}
                        fontSize="15px"
                        fontWeight={700}
                        color="#e5e7eb"
                        letterSpacing="-0.01em"
                        sx={{
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          lineHeight: 1.4,
                        }}
                      >
                        {course.title}
                      </Typography>

                      {/* Author */}
                      <Typography
                        fontFamily={interFont}
                        fontSize="12px"
                        color="#6b7280"
                      >
                        by{" "}
                        <span
                          style={{
                            color: primary,
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            // Store any necessary data if needed
                            if (course?.id) {
                              localStorage.setItem("selectedCourseId", course.id);
                            }
                            // Redirect to generated-blogs page
                            window.open(`${window.location.origin}/profile/${course.user?.profile_id}`);
                          }}
                        >
                          {course.user.first_name+" "+course.user.last_name}
                        </span>
                      </Typography>

                      {/* Description */}
                      <Typography
                        fontFamily={interFont}
                        fontSize="13px"
                        color="#9ca3af"
                        sx={{
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          lineHeight: 1.55,
                        }}
                      >
                        {course.description}
                      </Typography>

                      {/* Rating */}
                      <Stack direction="row" spacing={1} alignItems="center" mt={0.5}>
                        <Box display="flex">
                          {renderStars(course?.average_rating)}
                        </Box>
                        <Typography
                          fontFamily={interFont}
                          fontSize="13px"
                          fontWeight={700}
                          color="#e5e7eb"
                        >
                          {course?.average_rating ?? 0}
                        </Typography>
                        <Typography
                          fontFamily={interFont}
                          fontSize="12px"
                          color="#6b7280"
                        >
                          {course?.total_reviews ?? 0} reviews
                        </Typography>
                      </Stack>

                      {/* Price */}
                      <Stack direction="row" spacing={1} alignItems="center" mt={0.3}>
                        <Typography
                          fontFamily={interFont}
                          fontWeight={700}
                          color="#e5e7eb"
                          fontSize="15px"
                          letterSpacing="-0.01em"
                        >
                          ${course.suggested_price} USD
                        </Typography>
                        <Typography
                          fontFamily={interFont}
                          fontSize="12px"
                          color="#6b7280"
                          sx={{ textDecoration: "line-through" }}
                        >
                          $
                          {course.old_price
                            ? course.old_price
                            : Math.round(course.suggested_price * 1.1)}
                        </Typography>
                      </Stack>

                      <Box sx={{ flexGrow: 1 }} />

                      {/* CTA Button */}
                      <Button
                        fullWidth
                        variant="contained"
                        disableElevation
                        endIcon={<ArrowForwardIcon fontSize="small" />}
                        sx={{
                          mt: 1,
                          fontFamily: interFont,
                          textTransform: "none",
                          borderRadius: "8px",
                          background: "#3b82f6",
                          fontSize: "14px",
                          fontWeight: 600,
                          py: 0.85,
                          color: "#fff",
                          boxShadow: "none",
                          letterSpacing: 0,
                          "&:hover": {
                            background: "#2563eb",
                            boxShadow: "none",
                          },
                        }}
                        onClick={() => {
                          localStorage.setItem("selected_course_id", course._id);

                          window.open(`${window.location.origin}${course?.url}`);
                          // navigate("/codegenie/individual-course", {
                          //   state: { courseId: course._id },
                          // });
                        }}
                      >
                        View Course
                      </Button>
                    </CardContent>
                  </Paper>
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <Box
                  sx={{
                    width: "100%",
                    py: 8,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    fontFamily={interFont}
                    fontSize={15}
                    color="#6b7280"
                  >
                    No courses found
                  </Typography>
                </Box>
              </Grid>
            )}
          </Grid>

          {/* Pagination */}
          {courses && courses.length > 0 && (
            <Stack direction="row" justifyContent="flex-end" mt={4}>
              <Pagination
                count={totalPages}
                page={page}
                onChange={(_: any, value: number) => setPage(value)}
                shape="rounded"
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    sx={{
                      width: 32,
                      height: 32,
                      minWidth: 32,
                      borderRadius: "6px",
                      fontFamily: interFont,
                      fontSize: 13,
                      color: "#d1d5db",
                      border: "1px solid #30363d",
                      backgroundColor: "#161b22",
                      "&.Mui-selected": {
                        backgroundColor: "#3b82f6",
                        color: "#ffffff",
                        border: "1px solid #3b82f6",
                      },
                      "&:hover": {
                        backgroundColor: "rgba(59,130,246,0.1)",
                        borderColor: primaryLight,
                      },
                      "&.MuiPaginationItem-ellipsis": {
                        backgroundColor: "transparent",
                        border: "none",
                        color: "#6b7280",
                      },
                    }}
                  />
                )}
              />
            </Stack>
          )}
        </Box>
      </Box>
    </>
  );
}